export default "__VITE_ASSET__BmJuwG3a__"